import Base from "./base"

export default class HallByRouteSlugExists extends Base {
  constructor(Vue, store) {
    super("hall-by-route-slug-exists", Vue, store)
  }

  async before(to, from, next) {
    const hallSlug = to.params.hallSlug

    if (_.isNull(hallSlug)) {
      next({name: "NotFound"})
      return
    }

    const hall = this.store.getters["hall/getBySlug"](hallSlug)

    if (_.isEmpty(hall)) {
      next({name: "NotFound"})
      return
    }

    // ホールルームに遷移しようとするが、ホールルームがない場合
    if (to.name === "HRoom" && !hall.has_self_room) {
      next({name: "NotFound"})
      return
    }

    next()
  }
}
